import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { Reveal } from "./Reveal";
import { STATS } from "@/lib/site-data";

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 2,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setN(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, value]);

  return (
    <span ref={ref} data-testid={`stat-counter-${value}`}>
      {n}
      <span className="text-cyan-400">{suffix}</span>
    </span>
  );
};

export default function Stats() {
  return (
    <section data-testid="stats-section" className="relative bg-black py-24 md:py-28 border-y border-white/10 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(0,102,255,0.12),transparent_60%)]" />
      <div className="relative max-w-7xl mx-auto px-4 md:px-8">
        <Reveal>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-10">
            {STATS.map((s) => (
              <div key={s.label} data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-center lg:text-left">
                <p className="font-display text-5xl md:text-6xl font-semibold tracking-tight">
                  <Counter value={s.value} suffix={s.suffix} />
                </p>
                <p className="mt-2 text-xs md:text-sm uppercase tracking-[0.2em] font-bold text-gray-400">
                  {s.label}
                </p>
                <div className="mt-4 h-[2px] w-10 bg-gradient-to-r from-[#00E5FF] to-[#0066FF] mx-auto lg:mx-0" />
              </div>
            ))}
          </div>
          <p className="mt-10 text-center lg:text-left text-xs text-gray-600">
            Figures shown are editable placeholders until verified numbers are provided.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
